export const generateFollowUpDates = (startDate, repeat, interval, count) => {
  const [year, month, day] = startDate.split("-").map(Number);

  return Array.from({ length: count }, (_, index) => {
    if (repeat === "weekly") {
      const date = new Date(Date.UTC(year, month - 1, day + index * interval * 7));
      return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, "0")}-${String(date.getUTCDate()).padStart(2, "0")}`;
    }

    if (repeat === "monthly") {
      const monthIndex = month - 1 + index * interval;
      const targetYear = year + Math.floor(monthIndex / 12);
      const targetMonth = monthIndex % 12;
      const lastDay = new Date(Date.UTC(targetYear, targetMonth + 1, 0)).getUTCDate();
      const targetDay = Math.min(day, lastDay);
      return `${targetYear}-${String(targetMonth + 1).padStart(2, "0")}-${String(targetDay).padStart(2, "0")}`;
    }

    return startDate;
  });
};
